import * as culture from "client_legacy/ndaw/culture";
import * as navigator from "client_legacy/ndaw/navigator";
import { alertBar } from "client_legacy/ndaw/alertBar";
import * as documentFileContentService from "client/Api/Documents/SharePoint/sharePointFileContent";
import { DocumentDownloadModel } from "client/Api/Documents/SharePoint/sharePointFileContent";
import * as fileDownloader from "client_legacy/ndaw/fileDownloader";
import { HttpRequestError } from "client/Api/httpClient";
import {
	DocumentItemViewModel,
	ListLocationModel,
	RecentDocumentItemViewModel
} from "client/Api/Documents/SharePoint/common";
import { getDownloadFileUrl, getOpenFileUrl } from "../UrlsProviders/documentsItemUrlsProviders";
import { convertToLocationModel } from "../listLocationModelProvider";

export function downloadDocument(document: DocumentItemViewModel | RecentDocumentItemViewModel): void {
	const newUrl: string = getDownloadFileUrl(document.id, document.location);
	fileDownloader.download(newUrl);
}

export function downloadDocumentInline(document: DocumentItemViewModel | RecentDocumentItemViewModel): void {
	// Download/open file in new tab/window
	// This only works without a popup blocker if its called directly from a user action (e.g. click)
	const openFileUrl: string = getOpenFileUrl(document);
	fileDownloader.openInline(openFileUrl);
}

export function downloadAsZip(documents: readonly DocumentItemViewModel[]): void {
	if (!fileDownloader.canDownload()) {
		fileDownloader.showCannotDownloadDialog();
		return;
	}

	const models: DocumentDownloadModel[] = [];

	const documentsLength: number = documents.length;

	// We need to open a window on a user created event else the browser on e.g. mobile/tablet won't allow it
	const windowObject: Window | null = fileDownloader.getOrCreateDownloadWindow();

	if (!windowObject) {
		alertBar.showTextAlert(culture.localize("_UnknownError"), "error");
		return;
	}

	for (let i = 0; i < documentsLength; i++) {
		const document: DocumentItemViewModel = documents[i];
		models.push({ id: document.id, name: document.name });
	}

	const location: ListLocationModel = convertToLocationModel(
		documents[0].location
	);

	documentFileContentService.downloadAsZip({ location, documents: models })
		.then(
			(requestId: string) => {
				const newUrl: string = navigator.createUrlRelativeToEnvironment("Documents/SharePoint/FileContent/GetZip?requestId=" + requestId);
				fileDownloader.downloadUsingWindow(newUrl, windowObject);
			},
			(reason) => {
				// Close the create window if it was created
				if (windowObject !== window) {
					windowObject.close();
				}

				let handled: boolean = false;
				if (reason instanceof HttpRequestError) {
					try {
						const failReason: string = reason.readJson<string>();
						handled = true;
						alertBar.showTextAlert(failReason, "error");
					} catch (e) {
						console.error(e);
					}
				}

				if (!handled) {
					alertBar.showTextAlert(culture.localize("_UnknownError"), "error");
				}
			}
		);
}
